import { render, staticRenderFns } from "./zhenliao-list.vue?vue&type=template&id=18344704&scoped=true&"
import script from "./zhenliao-list.vue?vue&type=script&lang=ts&"
export * from "./zhenliao-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18344704",
  null
  
)

export default component.exports